import React from "react";
import Layout from "components/Layout";
import { get_tdk } from "api/server/tdk";
import { Util } from "@xt/xtbase";
import AiSelectHome from "@/components/Pages/Market/AiSelectHome";

const { getOrigin } = Util;

export default function PageAiSelect() {
  return (
    <Layout isShowNav={false} isShowFoot={false}>
      <AiSelectHome />
    </Layout>
  );
}

export async function getStaticProps(context) {
  const resolvedUrl = "/aiselect";
  const props = { resolvedUrl };
  try {
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale,
      },
    });
    props.tdk = tdk || {};
  } catch (error) {
    props.tdk = {};
  }
  return {
    props,
    revalidate: 60,
  };
}
